var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTw = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4.426a8.231 8.231 0 01-2.358.645A4.104 4.104 0 0019.444 2.8a8.222 8.222 0 01-2.604.997 4.104 4.104 0 00-6.99 3.741A11.638 11.638 0 011.393 3.25a4.092 4.092 0 00-.556 2.062 4.098 4.098 0 001.826 3.415 4.092 4.092 0 01-1.858-.515v.05a4.105 4.105 0 003.291 4.023 4.158 4.158 0 01-1.853.069 4.108 4.108 0 003.832 2.85 8.229 8.229 0 01-5.097 1.759c-.33 0-.655-.021-.978-.057a11.609 11.609 0 006.29 1.844c7.546 0 11.671-6.252 11.671-11.674 0-.18-.002-.355-.011-.531a8.297 8.297 0 002.047-2.124l.003.005z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTw, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tw.dc5e6bc9.svg";
export { ForwardRef as ReactComponent };